"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _exclamationCircleFilled = _interopRequireDefault(require("@spothero/icons/exclamation-circle-filled"));
const FormGroupError = ({
  className,
  children
}) => {
  const classes = (0, _classnames.default)('FormGroupError', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement(_exclamationCircleFilled.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "FormGroupError-content"
  }, children));
};
var _default = exports.default = FormGroupError;